angular.module('3ema.components', []);
import toggleButton from './components/toggle_button';
angular.module('3ema.components').component('toggleButton', toggleButton);
